import { gql } from '@apollo/client'
import { useSort } from '@btime/react-contexts'
import React from 'react'

import { serviceOrdersClient } from '../../../../utils/apollo/api'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../components/helpers/LazyAction'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const useServiceOrdersState = () => React.useContext(Context) || {}
export const useServiceOrders = () => useServiceOrdersState()?.serviceOrders || []

const QUERY = gql`
  query ServiceOrders($page: Int, $search: String, $sort: ServiceOrderSort, $filter: ServiceOrderFilter) {
    serviceOrders(page: $page, search: $search, sort: $sort, filter: $filter) {
      id
      yearlyId
      place {
        id
        name
        resume
      }
      user {
        id
        name
      }
      group {
        id
        name
      }
      groups {
        id
        name
      }
      checklist {
        id
        name
      }
      status {
        id
        name
      }
    }
  }
`

const ServiceOrdersLoader = ({ children, uncontrolledChildren }) => {
  const { field, type } = useSort()
  const formReplyId = useModalData()

  const { data, fetchMore, variables, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      sort: { field: field || 'INSERTED_AT', type: type || 'DESC' },
      filter: { ignoreSegments: true, formReplyIds: formReplyId }
    },
    client: serviceOrdersClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading || state.isFetchingMore} />
      </StatePresenter>
    </Provider>
  )
}

export default ServiceOrdersLoader
